module.exports = __webpack_public_path__ + "static/media/transparency.73b84dcc.png";